<template>
  <div class="my-quiz-card" @click="$emit('click', $event)">
    <div class="tag-wrapper" v-if="isQuizTags">
      <div class="tag" v-for="(value, index) in getQuizTags(quiz)" :key="index">
        {{ value }}
      </div>
    </div>
    <div class="title">{{ quiz.content || '-' }}</div>
    <div class="quiz-type">{{ getQuizTypeName }}</div>
    <div class="date">최초 생성일 {{ getQuizCreatedDate }}</div>
    <div class="divider" />
    <div class="row stats-wrapper">
      <div class="col-3">
        <div class="label">정답수</div>
        <div class="value">{{ getToCommas(getCorrectResultsCount) }}</div>
      </div>
      <div class="col-6">
        <div class="label">총 문제 푼수</div>
        <div class="value">{{ getToCommas(getTotalResultsCount) }}</div>
      </div>
      <div class="col-3 quiz-state-wrapper">
        <div class="quiz-state" :class="getQuizState(getQuizSet).value">
          {{ getQuizState(getQuizSet).label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { format } from 'date-fns';
  import { isEmpty } from 'lodash';
  import numbers from '@/mixins/numbers';
  import quiz from '../mixins/quiz';

  export default {
    name: 'my-quiz-card',

    props: {
      quiz: {
        type: Object,
        default: {},
      },
    },

    mixins: [
      numbers,
      quiz,
    ],

    computed: {
      isQuizTags() {
        return !isEmpty(this.getQuizTags(this.quiz));
      },

      getQuizTypeName() {
        if (this.isNoOptionsQuiz(this.quiz.options)) {
          return 'OX퀴즈';
        }

        if (!this.isNoOptionsQuiz(this.quiz.options)) {
          return '객관식(4지선다)';
        }

        return '';
      },

      getQuizSet() {
        return this.quiz.quiz_set || {};
      },

      getCorrectResultsCount() {
        return this.quiz.correct_results_count || 0;
      },

      getTotalResultsCount() {
        return (this.quiz.incorrect_results_count + this.getCorrectResultsCount) || 0;
      },

      getQuizCreatedDate() {
        if (!this.getQuizSet.created_at) {
          return '-';
        }

        return format(new Date(this.getQuizSet.created_at), 'yyyy-MM-dd');
      },

    },

  };
</script>

<style lang="scss" scoped>
  .my-quiz-card {
    height: 214px;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
    padding: 18px;
    cursor: pointer;

    .tag-wrapper {
      display: flex;
      align-items: center;
      padding: 0 0 6px 0;

      .tag {
        margin: 0 8px 0 0;
        font-size: 14px;
        color: #9013fe;
      }
    }


    .title {
      font-size: 16px;
      font-weight: bold;
      line-height: 1.5;
      color: rgba(0, 0, 0, 0.87);
      margin: 0 0 8px 0;
      overflow: hidden; 
      text-overflow: ellipsis; 
      white-space: nowrap;
    }

    .quiz-type {
      font-size: 14px;
      font-weight: bold;
      line-height: 1.43;
      color: rgba(0, 0, 0, 0.38);
    }

    .date {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.38);
    }

    .divider {
      width: 100%;
      height: 1px;
      margin: 12px 0 12px 0;
      background-color: #d8d8d8;
    }


    .stats-wrapper {

      .label {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.54);
      }

      .value {
        font-size: 30px;
        color: #00c896;
      }

      .quiz-state-wrapper {

        .quiz-state {
          text-align: center;
          padding: 10px;
          font-size: 14px;
          height: 38px;
          border-radius: 30px;
          margin: 10px;
          color: #35353b;
          background: rgba(0, 0, 0, 0.1);

          &.under_review {
            background: rgba(245, 166, 35, 0.1);
            color: #f5a623;
          }

          &.review_completed {
            background: rgba(0, 200, 150, 0.08);
            color: #00c896;
          }

          &.active {
            color: #9013fe;
            background: rgba(144, 19, 254, 0.1);
          }

          &.end {
            color: #35353b;
            background: rgba(0, 0, 0, 0.1);
          }

        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/app/my-quizzes/components/MyQuizCard.vue